import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({ width, height }) => {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        margin: "auto",
        width: width ? width : "100px",
        height: height ? height : "100px",
        display: "block",
        color: "#002c53",
      }}
    >
      <span className="sr-only">Loading...</span>
    </Spinner>
  );
};

export default Loader;
